import React from 'react';
import { Award, BookOpen, Users, Lightbulb } from 'lucide-react';

export default function AboutPage() {
  return (
    <main className="bg-gray-50">
      <div className="relative py-16 bg-white overflow-hidden">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto">
            <h1>
              <span className="block text-base text-center text-blue-600 font-semibold tracking-wide uppercase">
                Notre Mission
              </span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                L'expertise au service de la formation
              </span>
            </h1>
          </div>

          <div className="mt-12 grid gap-8 max-w-4xl mx-auto">
            <div className="relative">
              <div className="prose prose-blue prose-lg text-gray-600 mx-auto">
                <p className="lead">
                  Cette plateforme de scénarios de formation est née d'une vision simple : 
                  mettre à disposition des formateurs en secourisme des outils pédagogiques 
                  de qualité, basés sur plus de trois décennies d'expérience terrain.
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mt-8">
              <div className="bg-blue-50 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <Award className="h-6 w-6 text-blue-600 mr-2" />
                  <h2 className="text-xl font-bold text-gray-900">Expertise Reconnue</h2>
                </div>
                <p className="text-gray-600">
                  Formateur certifié CNESST, instructeur sénior Cœur et AVC, et ancien formateur 
                  PDSP accrédité par l'ASSTSAS, notre expertise couvre tous les aspects des 
                  premiers soins et de la réanimation cardio-respiratoire.
                </p>
              </div>

              <div className="bg-blue-50 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <Users className="h-6 w-6 text-blue-600 mr-2" />
                  <h2 className="text-xl font-bold text-gray-900">Formation Professionnelle</h2>
                </div>
                <p className="text-gray-600">
                  Une expérience approfondie dans la formation professionnelle, notamment 
                  dans la préparation des préposés aux bénéficiaires, garantit des scénarios 
                  adaptés aux réalités du terrain.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8 mt-8">
              <div className="flex items-center mb-6">
                <Lightbulb className="h-8 w-8 text-blue-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">Notre Approche Pédagogique</h2>
              </div>
              <p className="text-gray-600 mb-6">
                En tant que concepteur pédagogique, nous développons des outils modernes 
                et efficaces pour soutenir les formateurs dans leur mission d'enseignement. 
                Cette bibliothèque de scénarios représente la synthèse de notre expertise, 
                offrant des mises en situation réalistes et progressives.
              </p>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-blue-600 font-bold text-xl mb-2">30+</div>
                  <div className="text-gray-600">Années d'expérience</div>
                </div>
                <div className="text-center">
                  <div className="text-blue-600 font-bold text-xl mb-2">3</div>
                  <div className="text-gray-600">Niveaux de difficulté</div>
                </div>
                <div className="text-center">
                  <div className="text-blue-600 font-bold text-xl mb-2">30</div>
                  <div className="text-gray-600">Scénarios détaillés</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}